import {
  HardDrive,
  KeySquare,
  List,
  Settings,
  Shield,
  Users,
} from "lucide-react";
import React from "react";
import { Button } from "../../components/ui/Button";
import { Card, CardContent } from "../../components/ui/Card";
import BackupSettingsTab from "./Tabs/BackupSettingsTab";
import { NomenclatorSettingsTab } from "./Tabs/NomenclatorSettingsTab";
import { SecuritySettingsTab } from "./Tabs/SecuritySettingsTab";
import { UserManagementTab } from "./Tabs/UserManagementTab";
import { TwoFactorAuthPage } from "./TwoFactorAuthPage";

export function SettingsPage() {
  const [selectedTab, setSelectedTab] = React.useState<
    "users" | "security" | "backup" | "nomenclator" | "2fa"
  >("users");

  return (
    <div className="p-6 space-y-8 bg-background min-h-screen">
      {/* Header */}
      <Card className="flex justify-between items-center ">
        <div className="flex items-center gap-2">
          <Settings className="w-8 h-8 text-blue-600" />
          <div>
            <h1 className="text-2xl font-bold text-foreground">
              Setări Sistem
            </h1>
            <p className="text-sm text-muted-foreground">
              Configurare și administrare sistem
            </p>
          </div>
        </div>
      </Card>

      {/* Settings Navigation */}
      <Card className="">
        <CardContent className="pt-6">
          <div className="flex gap-4">
            <Button
              variant={selectedTab === "users" ? "default" : "outline"}
              onClick={() => setSelectedTab("users")}
              className="flex items-center gap-2"
            >
              <Users className="w-4 h-4" />
              Utilizatori
            </Button>
            <Button
              variant={selectedTab === "security" ? "default" : "outline"}
              onClick={() => setSelectedTab("security")}
              className="flex items-center gap-2"
            >
              <Shield className="w-4 h-4" />
              Securitate
            </Button>
            <Button
              variant={selectedTab === "backup" ? "default" : "outline"}
              onClick={() => setSelectedTab("backup")}
              className="flex items-center gap-2"
            >
              <HardDrive className="w-4 h-4" />
              Backup
            </Button>
            <Button
              variant={selectedTab === "nomenclator" ? "default" : "outline"}
              onClick={() => setSelectedTab("nomenclator")}
              className="flex items-center gap-2"
            >
              <List className="w-4 h-4" />
              Nomenclator
            </Button>
            <Button
              variant={selectedTab === "2fa" ? "default" : "outline"}
              onClick={() => setSelectedTab("2fa")}
              className="flex items-center gap-2"
            >
              <KeySquare className="w-4 h-4" />
              Autentificare 2FA
            </Button>
          </div>
        </CardContent>
      </Card>

      {/* User Management */}

      {selectedTab === "users" && (
        <UserManagementTab selectedTab={selectedTab} />
      )}

      {/* Security Settings */}
      {selectedTab === "security" && (
        <SecuritySettingsTab selectedTab={selectedTab} />
      )}

      {/* Backup Settings */}
      {selectedTab === "backup" && (
        <BackupSettingsTab selectedTab={selectedTab} />
      )}

      {/* Nomenclator Settings */}
      {selectedTab === "nomenclator" && (
        <NomenclatorSettingsTab selectedTab={selectedTab} />
      )}
      {selectedTab === "2fa" && <TwoFactorAuthPage />}
    </div>
  );
}
